import { PopupWrapper, PrimaryButton, SecondaryButton } from "ui";
import { useQueueWorkflowStore } from "@elixir/stores";
import { SparklesSolidIcon } from "@elixir/icons";
import { WORKFLOW_VIEW_POPUP_STATE } from "@elixir/types";

const CreateViewIntro = () => {
  const createViewPopupState = useQueueWorkflowStore(
    (state) => state.createViewPopupState
  );
  const setCreateViewPopupState = useQueueWorkflowStore(
    (state) => state.setCreateViewPopupState
  );

  return (
    <PopupWrapper
      open={createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.INTRO}
      onClose={() => {
        setCreateViewPopupState(undefined);
      }}
      onOk={() => {}}
      width={341}
      hideHeader={true}
      hideFooter={true}
    >
      <div className="p-16 dr-flex dr-flex-col">
        <span className="dr-text-darwin-touch-green-primary dr-px-8 dr-py-4 dr-bg-darwin-touch-green-bg-light dr-rounded-4 dr-max-w-min dr-flex dr-flex-row dr-items-center">
          <span className="dr-italic">New</span>
          <SparklesSolidIcon className="dr-w-10 dr-h-14 dr-ml-4" />
        </span>
        <p className="dr-py-4 SubheadlineBold">
          Use queues to streamline your workflow across different departments
          and staff
        </p>
        <div
          className="dr-h-148 dr-rounded-6"
          style={{ backgroundColor: "#D9D9D9" }}
        ></div>
        <span className="dr-italic BodyRegular dr-text-doctor-darwin-neutral-600 dr-py-4">
          Eg. Use the filters to create a view with all the patients{" "}
          <span className="dr-text-doctor-darwin-neutral-800 BodyBold">
            “Assigned to- Nursing department”
          </span>{" "}
          and{" "}
          <span className="dr-text-doctor-darwin-neutral-800 BodyBold">
            “Ready for vital collection”
          </span>
        </span>
        <div className="flex flex-row dr-justify-end dr-gap-8">
          <SecondaryButton onClick={() => {}} title="Learn more" />
          <PrimaryButton
            onClick={() =>
              setCreateViewPopupState(WORKFLOW_VIEW_POPUP_STATE.VIEW_NAMING)
            }
            title="Get started"
          />
        </div>
      </div>
    </PopupWrapper>
  );
};

export default CreateViewIntro;
